<template>
  <div class="xcxUpload">
    <div class="aside">
      <div class="aside-w">
        <img
          class="local"
          :src="require('/src/assets/img/upload/photo.png')"
          alt="本地上传"
        />
        <label v-if="isIos" class="upload">
          请选择文件
          <input ref="fileInput" multiple type="file" @change="callAsync" />
        </label>
        <label v-else class="upload">
          请选择文件
          <input ref="fileInput" type="file" @change="callAsync" />
        </label>
        <h3 class="tips">禁止上传涉政、涉密等违法文件，一经发现将依法处理</h3>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { REQUEST_URL, CLOUD_REQUEST_URL, APP_KEY } from "src/const/const";
import { BMF } from "src/utils/utils";
import Miniprogram from "utils/miniprogram";

const miniProgram = new Miniprogram();
let instance;

export default {
  data() {
    return {
      isIos: false
    };
  },
  mixins: [],
  mounted() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      this.isIos = true;
    }
  },
  methods: {
    /**
     * [callAsync 同步执行]
     *
     * @param   {[type]}  e  [e description]
     *
     * @return  {[type]}     [return description]
     */
    async callAsync(e) {
      this.$message.loading({
        forbidClick: true,
        message: "上传中...",
        duration: 0
      });
      this.clearShow = !this.clearShow;
      if (e.target.files.length > 10) {
        e.target.value = "";
        return this.$message("文件数量超出限制，最多支持10个文件");
      }
      this.printList = [];
      if (e.target.files.length === 1) {
        const file = e.target.files[0];
        e.target.value = "";
        miniProgram.init().then(res => {
          // qq小程序需要用户点击才能触发加载js
          instance = res;
          // 走单选流程
          const fileName = file.name;
          const { size } = this.$route.query;
          if (file.size > Number(size)) return this.$message("上传文件过大!");
          if (!this.checkExtName(fileName))
            return this.$message("不支持上传该文件类型!");
          BMF.md5(file, (err, md5) => {
            if (err && !md5) return this.$message("获取文件md5失败");
            // 上传文件
            this.uploadDocument(file, md5);
          });
        });
      } else {
        const { files } = e.target;
        miniProgram.init().then(res => {
          // qq小程序需要用户点击才能触发加载js
          instance = res;
          // 批量
          Promise.all(Array.from(files).map(item => this.uploadPromise(item)))
            .then(() => {
              instance.miniProgram.navigateBack();
              instance.miniProgram.postMessage({
                data: {
                  printList: this.printList
                }
              });
            })
            .catch(() => {
              this.$message("网络波动，请重试");
              setTimeout(() => {
                instance.miniProgram.navigateBack();
              }, 1000);
            });
        });
      }
    },
    uploadPromise(file) {
      return new Promise((resolve, reject) => {
        const fileName = file.name;
        const { size } = this.$route.query;
        if (file.size > Number(size)) {
          this.printList.push({
            errMsg: "上传文件过大",
            fileName
          });
          return resolve("上传文件过大");
        }
        if (!this.checkExtName(fileName)) {
          this.printList.push({
            errMsg: "不支持的文件类型",
            fileName
          });
          return resolve("不支持的文件类型");
        }
        BMF.md5(file, (err, md5) => {
          if (err && !md5) {
            this.printList.push({
              errMsg: "文件md5检验失败",
              fileName
            });
            return resolve("文件md5检验失败");
          }
          // 上传文件
          this.uploadDocument(file, md5, true).then(() => {
            resolve();
          });
        });
      });
    },
    /**
     * [callAsync 同步执行]
     *
     * @param   {[type]}  e  [e description]
     *
     * @return  {[type]}     [return description]
     */
    checkExtName(fileName) {
      const extName = this.getExtName(fileName);
      if (!extName) return false;
      const { type } = this.$route.query;
      if (type.split(",").find(item => item === extName)) return true;
      return false;
    },
    /**
     * [uploadDocument 上传文件]
     *
     * @return  {[type]}  [return description]
     */
    uploadDocument(file, md5, isBatch) {
      const { t, act, wxOpenId } = this.$route.query;
      let params = new FormData();
      params.append("file", file);
      params.append("md5", md5);
      params.append("wxOpenId", wxOpenId);
      // wt有 为云办公账号
      const headers = t
        ? {
            "Content-Type":
              "multipart/form-data;boundary = " + new Date().getTime(),
            token: t,
            appKey: APP_KEY
          }
        : {
            "Content-Type":
              "multipart/form-data;boundary = " + new Date().getTime(),
            appKey: APP_KEY,
            Authorization: `Bearer ${act}`
          };
      return new Promise((resolve, reject) => {
        const service = axios.create({
          withCredentials: true,
          headers
        });
        const url = `${REQUEST_URL}/printDocConvert/uploadConvert`;
        service
          .post(url, params)
          .then(({ data: res }) => {
            const { highPrint } = this.$route.query;
            if (res.code === 0) {
              if (isBatch) {
                this.printList.push(
                  highPrint === "2" ? { ...res.data, highPrint } : res.data
                );
                resolve();
              } else {
                this.$message("上传成功！");
                setTimeout(() => {
                  instance.miniProgram.navigateBack();
                  instance.miniProgram.postMessage({
                    data: {
                      printList: [
                        highPrint === "2"
                          ? { ...res.data, highPrint }
                          : res.data
                      ]
                    }
                  });
                }, 1000);
              }
            } else {
              if (isBatch) {
                this.printList.push({
                  errMsg: "上传失败",
                  fileName
                });
              } else {
                this.$message("网络波动，请重试");
                setTimeout(() => {
                  instance.miniProgram.navigateBack();
                }, 1000);
              }
            }
          })
          .catch(() => {
            if (isBatch) {
              this.printList.push({
                errMsg: "上传失败",
                fileName
              });
            } else {
              this.$message("网络波动，请重试");
              setTimeout(() => {
                instance.miniProgram.navigateBack();
              }, 1000);
            }
          });
      });
    }
  },
  created() {
    document.title = "福昕智慧打印";
  },
  computed: {},
  components: {}
};
</script>

<style lang="scss" scoped>
.xcxUpload {
  height: 100%;
  padding-top: 90px;
  .aside {
    width: 100%;
    .local {
      width: 376px;
      height: 340px;
      display: block;
      margin: 0 auto 120px;
    }
    .upload {
      width: 400px;
      border-radius: 50px;
      height: 100px;
      line-height: 100px;
      text-align: center;
      background: #2f54eb;
      display: block;
      color: #fff;
      font-size: 28px;
      margin: 0 auto;
      font-weight: 500;
      font-size: 36px;
      border: none;
      outline: none;
      position: relative;
    }
  }
  input {
    display: none;
  }
}
.tips {
  font-size: 26px;
  padding-top: 32px;
  color: #999999;
  text-align: center;
}
</style>
